import script from "./ClientLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientLogin.vue?vue&type=script&setup=true&lang=ts"

import "./ClientLogin.vue?vue&type=style&index=0&id=229fe5ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229fe5ae"]])

export default __exports__